import { useQuery } from '@tanstack/react-query';
import type { Report } from './interfaces';
import { mediaClient } from '@/data/@clients';

export const useLmsReport = () => {
  const { data, isLoading, error } = useQuery<Report[]>({
    queryKey: ['lms-report'],
    queryFn: async () => {
      const response = await mediaClient.get('/courses/report');
      return Array.isArray(response) ? response : response?.data || [];
    },
  });

  return {
    report: data ?? [],
    isLoading,
    error,
  };
};
